import { createSlice } from "@reduxjs/toolkit";
import { getActiveUser } from "../../../utils/common-utils";

const getUser = () => {
  const user = getActiveUser();
  if (user) {
    return JSON.parse(user);
  }

  return {};
};

const authenticationSlice = createSlice({
  name: "Authentication",
  initialState: {
    traceId: "",
    authToken: "",
    userExists: false,
    user: getUser(),
    phoneNumber: "",
  },
  reducers: {
    setIdentificationTraceId(state, action) {
      state.traceId = action.payload;
    },

    setUserPhoneNumber(state, action) {
      state.phoneNumber = action.payload;
    },

    setUsetExists(state, action) {
      state.userExists = action.payload;
    },

    setUserAuthToken(state, action) {
      state.authToken = action.payload;
    },

    setAuthRefreshToken(state, action) {
      state.user = action.payload;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },

    setUserAuth(state, action) {
      const { authToken, refreshToken } = action.payload;

      localStorage.setItem("user", JSON.stringify({ refreshToken }));

      state.user = { refreshToken };
      state.authToken = authToken;
    },

    setNotificationToggle(state, action) {
      state.newNotification = action.payload;
    },

    logoutUser(state) {
      state.authToken = "";
      state.user = {};
    },
  },
});

export const authenticationSliceActions = authenticationSlice.actions;

export default authenticationSlice.reducer;
